import type { Channel, Coverage, OfferViewModel } from "@/api_client";

import { getEcommerceVerifyAndBuy } from "./data/ecommerce";
import type { VerifyAndBuyEvent } from "./types/types";

export const createVerifyAndBuyEvent = (
  offer: OfferViewModel,
  channel: Channel,
  coverageContent: Record<string, Coverage> | undefined,
): VerifyAndBuyEvent | undefined => {
  if (!offer?.quotes) {
    return;
  }
  return {
    event: "Verify and Buy",
    ecommerce: getEcommerceVerifyAndBuy(offer.quotes, channel, coverageContent),
  };
};
